<template>
	<div class="page-container">
		<md-dialog-alert
	      :md-active.sync="alert"
	      :md-content="msgAlert"
	      md-confirm-text="Ok" />
		<md-dialog-confirm
		:md-active.sync="cancel"
			md-title="Confirmar Cancelamento"
			:md-content="cancelMsg"
			md-confirm-text="Sim"
			md-cancel-text="Não"
			@md-confirm="confirmCancel" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Bilhetes
				</span>
			</md-app-toolbar>
			<md-app-content>
				<div class="fundo-geral" style="min-height: 100%;">
					<md-card>
						<md-card-content style="padding-top: 0;padding-bottom: 0;">
							<div class="md-layout md-gutter" v-if="!hideFilter">
			            		<div class="md-layout-item">
									<md-datepicker v-model="de" md-immediately />
								</div>
								<div class="md-layout-item">
									<md-datepicker v-model="ate" md-immediately />
								</div>
							</div>
							<div class="md-layout md-gutter" v-if="!loadingBets">
								<div class="md-layout-item" v-if="!hideFilter">
									<md-button class="md-raised md-primary" style="width: 95%;" @click="filtrar()">FILTRAR</md-button>
								</div>
								<div class="md-layout-item">
									<md-button class="md-raised md-primary" style="width: 95%;" @click="toggleFilter()"><md-icon>{{ titleBtnToggleFilter }}</md-icon></md-button>
								</div>
							</div>
						</md-card-content>
					</md-card>
					<div class="md-layout md-gutter md-alignment-center-center" v-if="loadingBets">
						<img class="titan-logo" src="../assets/loading.gif" style="width: 90px;">
					</div>
					<div class="md-layout" v-if="!loadingBets">
						<div v-for="bet in bets" class="md-layout-item md-size-100" style="margin-top: 10px;">
							<md-card style="padding: 0;">
								<md-card-content style="padding: 0px;">
									<div class="md-layout fundo-ticket-number-even" v-bind:class="verifyClass(bet.nomeStatus)" style="height: 35px; line-height: 35px;">
										<div class="md-layout-item" style="text-align: center;">{{ bet.numeroBilhete }}</div>
									</div>
									<div style="padding-left: 10px; padding-right: 10px;" class="md-layout">
										<div class="md-layout-item">Apostador: {{ bet.apostador }}</div>
									</div>
									<div style="padding-left: 10px; padding-right: 10px;" class="md-layout">
										<div class="md-layout-item">Data: {{ bet.momento }}</div>
									</div>
									<div style="padding-left: 10px; padding-right: 10px;" class="md-layout">
										<div class="md-layout-item">Status: {{ traduzStatus(bet.nomeStatus) }}</div>
									</div>
									<div style="padding-left: 10px; padding-right: 10px;" class="md-layout">
										<div class="md-layout-item">Valor: R$ {{ bet.valorPago }}</div>
									</div>
									<div style="padding-left: 10px; padding-right: 10px;" class="md-layout">
										<div class="md-layout-item">Possível Retorno: R$ {{ bet.valorPremio }}</div>
									</div>
									<div style="padding-left: 10px; padding-right: 10px;" class="md-layout">
										<div class="md-layout-item">Comissão: R$ {{ bet.valorComissao }}</div>
									</div>
									<div style="padding-left: 10px; padding-right: 10px;" class="md-layout">
										<div class="md-layout-item">Eventos: {{ bet.qtdEventos }}</div>
									</div>

									<div class="md-layout" style="padding-right: 5px;">
										<div class="md-layout-item md-small">
											<md-button class="md-raised md-primary" style="width: 95%;background-color: #17a717;" @click="visualizar(bet.numeroBilhete)">VISUALIZAR</md-button>
										</div>
										<div class="md-layout-item md-small" v-if="bet.nomeStatus == 'p'">
											<md-button class="md-raised md-accent" style="width: 95%;" @click="cancelar(bet.numeroBilhete)">CANCELAR</md-button>
										</div>
									</div>
								</md-card-content>
							</md-card>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'

	export default {
		name: 'TitanMyTickets',
		data () {
			return {
				de: new Date(),
				ate: new Date(),
				alert: false,
			    msgAlert: "",
			    loadingBets: false,
			    bets: [],
			    hideFilter: true,
			    cancel: false,
			    cancelMsg: "",
			    numeroCancelamento: null
			}
		},
        methods: {
        	backHome: function() {
        		this.$router.push({ name: 'TitanHome'})
        	},
        	filtrar: function() {
        		this.loadingBets = true

        		var de = moment(this.de);
        		var ate = moment(this.ate);
        		if (!(de.isValid()) || !(ate.isValid())) {
        			this.msgAlert = "Período inválido."
        			this.alert = true
        			return false;
        		}

        		this.$store.commit('TICKETS_FILTER', { 'de': this.de, 'ate': this.ate })

        		var config = {
				  headers: {Authorization: 'Bearer  ' + this.$store.state.usuario.token}
				};

        		axios
				.get(this.$root.$data.API_URL + 'seller/bets/' + de.format("YYYY-MM-DD") + "/" + ate.format("YYYY-MM-DD"), config)
				.then(response => {
					this.loadingBets = false

					let result = response.data
					if (result.success) {
						this.bets = result.bets
					}
					else {
						this.msgAlert = result.message
        				this.alert = true
					}
		        });
        	},
        	cancelar: function(numero) {
        		this.cancelMsg = "Deseja cancelar o bilhete número <span style='font-weight: bold; color: red;'>" + numero + "</span>?"
        		this.cancel = true
        		this.numeroCancelamento = numero
        	},
        	confirmCancel: function() {
        		if (this.numeroCancelamento != null) {
        			var config = {
					  headers: {Authorization: 'Bearer  ' + this.$store.state.usuario.token}
					};

	        		axios
					.get(this.$root.$data.API_URL + 'seller/bet/cancel/' + this.numeroCancelamento, config)
					.then(response => {
						this.loadingBets = false

						let result = response.data

						if (result.success) {
							this.msgAlert = "Bilhete cancelado com sucesso."
							this.filtrar()
						}
						else {
							this.msgAlert = result.message

						}
						this.alert = true
			        });
        		}
        	},
        	toggleFilter: function() {
        		this.hideFilter = !this.hideFilter
        	},
			traduzStatus: function(status) {
				if (status == 'l') return 'Perdeu'
				else if (status == 'w') return 'Ganhou'
				else if (status == 'c') return 'Encerrado'
				else if (status == 'ca') return 'Cancelada'
				else return 'Pendente'
			},
			visualizar: function(numero) {
				this.$router.push({ name: 'TitanReprint', params: { id: numero }})
			},
			verifyClass: function(status) {
				return {
					'status-pendente': (status == 'p'),
					'status-win': (status == 'w'),
					'status-lose': (status == 'l'),
					'status-canceled': (status == 'ca'),
					'status-closed': (status == 'c'),
				}
			}
        },
        mounted() {
        	//console.log(this.$store.state.tickets_filter)
        	if (this.$store.state.tickets_filter) {
				this.de = this.$store.state.tickets_filter.de
				this.ate = this.$store.state.tickets_filter.ate
			}

			this.filtrar()
		},
		computed: {
			titleBtnToggleFilter: function() {
				if (this.hideFilter) return 'keyboard_arrow_down'
				else return 'keyboard_arrow_up'
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #303F9F, // The primary color of your brand
	accent: #226DA7 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/TitanMyTickets.vue